// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

// Keep this manually:
import AccordionController from '@kanety/stimulus-accordion';
application.register('accordion', AccordionController);

import AdminPreviewController from "./admin_preview_controller"
application.register("admin-preview", AdminPreviewController)

import ArchiveModalController from "./archive_modal_controller"
application.register("archive-modal", ArchiveModalController)

import BarGraphController from "./bar_graph_controller"
application.register("bar-graph", BarGraphController)

import BasketController from "./basket_controller"
application.register("basket", BasketController)

import BatchAddController from "./batch_add_controller"
application.register("batch-add", BatchAddController)

import CalibrateOrientationController from "./calibrate_orientation_controller"
application.register("calibrate-orientation", CalibrateOrientationController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CohortProgressesDeliveriesTableController from "./cohort_progresses_deliveries_table_controller"
application.register("cohort-progresses-deliveries-table", CohortProgressesDeliveriesTableController)

import CohortReportController from "./cohort_report_controller"
application.register("cohort-report", CohortReportController)

import ColumnSelectorController from "./column_selector_controller"
application.register("column-selector", ColumnSelectorController)

import ConcertinaController from "./concertina_controller"
application.register("concertina", ConcertinaController)

import ContentLibraryModalController from "./content_library_modal_controller"
application.register("content-library-modal", ContentLibraryModalController)

import CopyBackupCodesController from "./copy_backup_codes_controller"
application.register("copy-backup-codes", CopyBackupCodesController)

import CountdownTimerController from "./countdown_timer_controller"
application.register("countdown-timer", CountdownTimerController)

import CourseSelectorController from "./course_selector_controller"
application.register("course-selector", CourseSelectorController)

import CurrentUseSelectorController from "./current_use_selector_controller"
application.register("current-use-selector", CurrentUseSelectorController)

import CurricularSummaryTabController from "./curricular_summary_tab_controller"
application.register("curricular-summary-tab", CurricularSummaryTabController)

import Dashboard__CardContentController from "./dashboard/card_content_controller"
application.register("dashboard--card-content", Dashboard__CardContentController)

import Dashboard__Student__CaseLearningTimeChartController from "./dashboard/student/case_learning_time_chart_controller"
application.register("dashboard--student--case-learning-time-chart", Dashboard__Student__CaseLearningTimeChartController)

import Dashboard__Student__CompletedAvailableCasesChartController from "./dashboard/student/completed_available_cases_chart_controller"
application.register("dashboard--student--completed-available-cases-chart", Dashboard__Student__CompletedAvailableCasesChartController)

import DashboardController from "./dashboard_controller"
application.register("dashboard", DashboardController)

import DocumentModalController from "./document_modal_controller"
application.register("document-modal", DocumentModalController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EditDeliveryController from "./edit_delivery_controller"
application.register("edit-delivery", EditDeliveryController)

import EducatorDashboardCardContentController from "./educator_dashboard_card_content_controller"
application.register("educator-dashboard-card-content", EducatorDashboardCardContentController)

import ElementCollapserController from "./element_collapser_controller"
application.register("element-collapser", ElementCollapserController)

import EnumSelectorController from "./enum_selector_controller"
application.register("enum-selector", EnumSelectorController)

import ExamCourseSchedulingController from "./exam_course_scheduling_controller"
application.register("exam-course-scheduling", ExamCourseSchedulingController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FilterSearchController from "./filter_search_controller"
application.register("filter-search", FilterSearchController)

import GridListViewController from "./grid_list_view_controller"
application.register("grid-list-view", GridListViewController)

import GroupSelectionController from "./group_selection_controller"
application.register("group-selection", GroupSelectionController)

import HelpController from "./help_controller"
application.register("help", HelpController)

import HighlightFocusController from "./highlight_focus_controller"
application.register("highlight-focus", HighlightFocusController)

import HovercardController from "./hovercard_controller"
application.register("hovercard", HovercardController)

import ImageGalleryController from "./image_gallery_controller"
application.register("image-gallery", ImageGalleryController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import ImportNewQuestionsController from "./import_new_questions_controller"
application.register("import-new-questions", ImportNewQuestionsController)

import MfaSendOtpController from "./mfa_send_otp_controller"
application.register("mfa-send-otp", MfaSendOtpController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MountReactOnRailsController from "./mount_react_on_rails_controller"
application.register("mount-react-on-rails", MountReactOnRailsController)

import MultiCohortCurricularSummaryTabController from "./multi_cohort_curricular_summary_tab_controller"
application.register("multi-cohort-curricular-summary-tab", MultiCohortCurricularSummaryTabController)

import NewDeliveryController from "./new_delivery_controller"
application.register("new-delivery", NewDeliveryController)

import NewExamVariationController from "./new_exam_variation_controller"
application.register("new-exam-variation", NewExamVariationController)

import NewProjectController from "./new_project_controller"
application.register("new-project", NewProjectController)

import NotifyProgramController from "./notify_program_controller"
application.register("notify-program", NotifyProgramController)

import OpenQuestionsController from "./open_questions_controller"
application.register("open-questions", OpenQuestionsController)

import OverflowDetectorController from "./overflow_detector_controller"
application.register("overflow-detector", OverflowDetectorController)

import OverlayController from "./overlay_controller"
application.register("overlay", OverlayController)

import PopupController from "./popup_controller"
application.register("popup", PopupController)

import PrintDocumentController from "./print_document_controller"
application.register("print-document", PrintDocumentController)

import ProjectDashboardController from "./project_dashboard_controller"
application.register("project-dashboard", ProjectDashboardController)

import ProjectsReportsController from "./projects_reports_controller"
application.register("projects-reports", ProjectsReportsController)

import QuestionStatsController from "./question_stats_controller"
application.register("question-stats", QuestionStatsController)

import QuizFormController from "./quiz_form_controller"
application.register("quiz-form", QuizFormController)

import QuizHoverController from "./quiz_hover_controller"
application.register("quiz-hover", QuizHoverController)

import QuizModalController from "./quiz_modal_controller"
application.register("quiz-modal", QuizModalController)

import QuizModeController from "./quiz_mode_controller"
application.register("quiz-mode", QuizModeController)

import QuizPlayerAuxController from "./quiz_player_aux_controller"
application.register("quiz-player-aux", QuizPlayerAuxController)

import RedirectController from "./redirect_controller"
application.register("redirect", RedirectController)

import ReducibleListController from "./reducible_list_controller"
application.register("reducible-list", ReducibleListController)

import ReportDateRangesController from "./report_date_ranges_controller"
application.register("report-date-ranges", ReportDateRangesController)

import ReportsDashboardController from "./reports_dashboard_controller"
application.register("reports-dashboard", ReportsDashboardController)

import ReportsSelectController from "./reports_select_controller"
application.register("reports-select", ReportsSelectController)

import ResetPopupConfirmationController from "./reset_popup_confirmation_controller"
application.register("reset-popup-confirmation", ResetPopupConfirmationController)

import RowOrderingController from "./row_ordering_controller"
application.register("row-ordering", RowOrderingController)

import RowSelectorController from "./row_selector_controller"
application.register("row-selector", RowSelectorController)

import SaqController from "./saq_controller"
application.register("saq", SaqController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SideNavigationPageController from "./side_navigation_page_controller"
application.register("side-navigation-page", SideNavigationPageController)

import SingleCohortReportController from "./single_cohort_report_controller"
application.register("single-cohort-report", SingleCohortReportController)

import SlideRightController from "./slide_right_controller"
application.register("slide-right", SlideRightController)

import SortColumnsController from "./sort_columns_controller"
application.register("sort-columns", SortColumnsController)

import SsmOptoutController from "./ssm_optout_controller"
application.register("ssm-optout", SsmOptoutController)

import StickyInfoController from "./sticky_info_controller"
application.register("sticky-info", StickyInfoController)

import StudentLearningProgressTableController from "./student_learning_progress_table_controller"
application.register("student-learning-progress-table", StudentLearningProgressTableController)

import SuccessBannerController from "./success_banner_controller"
application.register("success-banner", SuccessBannerController)

import TextDecorationController from "./text_decoration_controller"
application.register("text-decoration", TextDecorationController)

import ToDoModalController from "./to_do_modal_controller"
application.register("to-do-modal", ToDoModalController)

import TodoFormController from "./todo_form_controller"
application.register("todo-form", TodoFormController)

import TodoListPageController from "./todo_list_page_controller"
application.register("todo-list-page", TodoListPageController)

import TurboRequestController from "./turbo_request_controller"
application.register("turbo-request", TurboRequestController)

import UpdateUserProfileController from "./update_user_profile_controller"
application.register("update-user-profile", UpdateUserProfileController)

import OpenReactModalController from "./open_react_modal_controller"
application.register("open-react-modal", OpenReactModalController)

import ViewToggleController from "./view_toggle_controller"
application.register("view-toggle", ViewToggleController)

import StudentPerformanceController from "./student_performance_controller"
application.register("student-performance", StudentPerformanceController)
